import { useState } from "react";
import { TagList } from "../components/home";
import { registerWidget, DME, DMEData, generalSettings } from "dmeditor";
import { Button, IconButton } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";

const degrees = [
  { name: "Bachelor", value: "bachelor" },
  { name: "Master", value: "master" },
  { name: "Doctorate", value: "doctorate" },
  { name: "Vocational", value: "vacational" },
  { name: "Associates", value: "associates" },
];
const list = [
  { name: "Agricultural", id: 1, bg: "bg-green-100" },
  { name: "Accounting", id: 2, bg: "bg-red-100" },
  { name: "Architecture", id: 3, bg: "bg-blue-100" },
  { name: "Business", id: 4, bg: "bg-green-100" },
  { name: "Engineering", id: 5, bg: "bg-yellow-100" },
  { name: "Law", id: 6, bg: "bg-blue-100" },
  { name: "Business", id: 7, bg: "bg-green-100" },
  { name: "Engineering", id: 8, bg: "bg-yellow-100" },
  { name: "Law", id: 9, bg: "bg-blue-100" },
  { name: "Business", id: 10, bg: "bg-green-100" },
  { name: "Engineering", id: 11, bg: "bg-yellow-100" },
  { name: "Law", id: 12, bg: "bg-blue-100" },
];

export const TagListRender = (props: DME.WidgetRenderProps) => {
  const {
    blockNode: { data },
  } = props;
  const { iconType } = data;

  const [selected, setSelected] = useState<Record<string, string>>({});
  const [subjects, setSubjects] = useState<string[]>([]);

  const labelClass =
    "w-1/4 border text-center rounded-3xl px-2 text-gray-700 bg-gray-200 py-1 whitespace-nowrap cursor-default";

  const tagContainerClass =
    "w-3/4 flex flex-col h-full justify-center gap-y-5 overflow-hidden";

  const [count, setCount] = useState<number | undefined>(undefined);

  const [sent, setSent] = useState(false);

  const search = () => {
    let query: string[] = [];
    if (selected) {
      for (const key of Object.keys(selected)) {
        query.push(key + "=" + selected[key]);
      }
    }
    fetch("/app/api/v1/school?" + query.join("&"))
      .then((res) => res.json())
      .then((data: any) => {
        if (data.count) {
          setSent(true);
          setCount(data.count);
        }
      });
  };

  return (
    <div className="lg:w-[100%] lg:px-0 2xl:pl-8">
      <div>
        <div className="block gap-1 mt-2 md:flex">
          <div className={labelClass}>Degree</div>
          <div className={tagContainerClass}>
            <TagList
              tags={degrees}
              value={selected["degree"]}
              onChange={(v) => setSelected({ ...selected, degree: v })}
            />
          </div>
        </div>
        <div className="block gap-1 mt-2 md:flex">
          <div className={labelClass}>Type</div>
          <div className={tagContainerClass}>
            <TagList
              tags={[
                { name: "Public", value: "1" },
                { name: "Private", value: "2" },
                { name: "State", value: "3" },
                { name: "Military", value: "4" },
                { name: "College Sports", value: "5" },
              ]}
              value={selected["schoolType"]}
              onChange={(v) => setSelected({ ...selected, schoolType: v })}
            />
          </div>
        </div>

        <div className="block gap-1 mt-2 md:flex">
          <div className={labelClass}>Tuition</div>
          <div className={tagContainerClass}>
            <TagList
              tags={[
                { name: "<5k", value: ",5000" },
                { name: "5k-10k", value: "5000,10000" },
                { name: "10k-15k", value: "10000,15000" },
                { name: "15k-20k", value: "15000,20000" },
                { name: "> 20k", value: "20000," },
              ]}
              value={[
                selected["costMin"] || "",
                selected["costMax"] || "",
              ].join(",")}
              onChange={(v) =>
                setSelected({
                  ...selected,
                  costMin: v.split(",")[0],
                  costMax: v.split(",")[1],
                })
              }
            />
          </div>
        </div>
        <div className="block gap-1 mt-2 md:flex">
          <div className={labelClass}>Scholarship</div>
          <div className={tagContainerClass}>
            <TagList
              tags={[
                { name: "Yes", value: "yes" },
                { name: "No", value: "no" },
              ]}
              value={selected["schoolship"]}
              onChange={(v) => setSelected({ ...selected, schoolship: v })}
            />
          </div>
        </div>
        <div className="block gap-1 mt-2 md:flex">
          <div className={labelClass}>College Sports</div>
          <div className={tagContainerClass}>
            <TagList
              tags={[
                { name: "NCAA I", value: "naaai" },
                { name: "NCAA II", value: "naaaii" },
                { name: "NCAA III", value: "naaaiii" },
                { name: "NAIA", value: "naia" },
              ]}
              value={selected["college_sports"]}
              onChange={(v) => setSelected({ ...selected, college_sports: v })}
            />
          </div>
        </div>

        <div className="mt-1 p-2 grid gap-2 grid-cols-3 md:grid-cols-5">
          {list.map((item) => (
            <a
              key={item.id}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                const newV = [...subjects];
                if (subjects.includes(item.id + "")) {
                  const index = subjects.findIndex(
                    (item1) => item1 === item.id + ""
                  );
                  newV.splice(index, 1);
                } else {
                  newV.push(item.id + "");
                }
                setSubjects(newV);
              }}
              className="cursor-pointer no-underline text-zdsecondary-800 dark:text-zdsecondary-300 hover:text-zdsecondary-600 dark:hover:text-zdsecondary-50"
            >
              <span
                className={
                  "px-2 py-1.5 inline-block " +
                  (subjects.includes(item.id + "") ? " font-bold " : "") +
                  " flex rounded text-gray-700 items-center justify-center whitespace-nowrap overflow-hidden " +
                  item.bg
                }
              >
                {item.name}
              </span>
            </a>
          ))}
        </div>
        <div className="mt-4">
          <span
            onClick={() => search()}
            className="rounded-full cursor-pointer bg-gray-700 px-4 py-2 text-white hover:bg-gray-600"
          >
            Try search result
          </span>
        </div>
        {sent && (
          <div className="mt-4 p-2 border">
            You got {count} matches.{" "}
            <a className="underline" href="#">
              What to know who they are?
            </a>
            <IconButton
              className="ml-4"
              onClick={() => {
                setSelected({});
                setSent(false);
              }}
            >
              <CloseOutlined />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default () => {
  registerWidget(
    {
      type: "mf-taglist",
      icon: "matchfit",
      name: "Tag list",
      category: "basic",
      settings: [...generalSettings],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "mf-taglist",
            data: {},
          };
        },
      },
    },
    {
      render: TagListRender,
    }
  );
};
